




















import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import Topic from '@/apps/website/model/topic'
import { saveMystudyPlanTopic } from '@/apps/website/api/study_plan_topic'
const ModuleGlobal = namespace('app-sandwich/global')

@Component
export default class AcswerTopic extends Vue {
  private active: number = -1
  private index: number = 1
  private btnText: string = '下一题'
  private titleStyle: string = 'margin-top: 94px'
  private btnStyle: string =
    'margin-top: 198px; background: #3AB599;opacity: 0.5;'
  private option: string = ''
  private topic: Topic = {
    title: '题目1:你是在校大学生吗？',
    index: 1,
    options: [
      { option: '是', bgcColor: 'background: 2c3744;' },
      { option: '否', bgcColor: 'background: 2c3744;' }
    ]
  }
  async mounted() {
    this.$emit('changeFooterConfig', {
      hasFooter: false,
      paddingBottom: 0
    })
  }
  select(option: string, index: number, key: any) {
    this.active = key
    this.option = option
    console.log(index)
    if (index === 2) {
      this.btnStyle = 'margin-top: 50px; background: #3AB599;'
    } else {
      this.btnStyle = 'margin-top: 198px; background: #3AB599;'
    }
  }
  async nextQuestion() {
    if (!this.option) {
      return
    }
    //添加我的答题结果
    await saveMystudyPlanTopic({
      topicIndex: this.index,
      accountId: '5df701d80f101ed7c25d9e99',
      answer: this.option
    })
    this.option = ''
    this.active = -1
    this.index++
    if (this.index === 2) {
      this.topic = {
        title: '以下编程语言/技术你最擅长的是？',
        index: 2,
        options: [
          { option: 'C/C++', bgcColor: 'background:2c3744;' },
          { option: 'Java', bgcColor: 'background: 2c3744;' },
          { option: 'Python', bgcColor: 'background: 2c3744;' },
          { option: 'HTML/CSS/JavaScript', bgcColor: 'background: 2c3744;' },
          { option: 'Vue/React', bgcColor: 'background: 2c3744;' },
          { option: 'Spring', bgcColor: 'background: 2c3744;' },
          { option: 'SQL', bgcColor: 'background: 2c3744;' },
          { option: '都不太会', bgcColor: 'background: 2c3744;' }
        ]
      }
      this.titleStyle = 'margin-top: 30px'
      this.btnStyle = 'margin-top: 50px; background: #3AB599;opacity: 0.5;'
    } else if (this.index === 3) {
      this.topic = {
        title: '题目3:你对你的数学满意么？',
        index: 3,
        options: [
          { option: '满意', bgcColor: 'background: 2c3744;' },
          { option: '不满意', bgcColor: 'background: 2c3744;' }
        ]
      }
      this.titleStyle = 'margin-top: 94px'
      this.btnStyle = 'margin-top: 198px; background: #3AB599;opacity: 0.5;'
      this.btnText = '查看结果'
    } else if (this.index === 4) {
      //跳转到推荐课程页面
      this.$router.push(`/home_m/recommended`)
    }
  }
}
